import { WorkspaceLightHeaderColorSchemes } from 'types'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import useResponsiveDesign from './useResponsiveDesign'
import { useDefaultTheme } from './useDefaultTheme'
import { getLuminance, hexToRgb } from 'utils/colorHelpers'

export const useWorkspaceColorScheme = () => {
  const workspace = useCurrentWorkspace()
  const defaultScheme = useDefaultTheme()
  const { isMobile } = useResponsiveDesign()

  const colorScheme = isMobile ? 'light' : workspace?.color_scheme ?? defaultScheme

  let isLight = WorkspaceLightHeaderColorSchemes.includes(colorScheme ?? defaultScheme)

  if (workspace?.is_whitelabel && workspace.white_label_color) {
    const rgb = hexToRgb(workspace.white_label_color)
    if (rgb) {
      const luminance = getLuminance(workspace.white_label_color)
      isLight = luminance > 0.5
    }
  }

  return {
    colorScheme,
    isLight,
  }
}
